<template>
  <div class="brl-bottom scroll-hidden">
    <global-loading v-if="$store.state.vaStore.total_vendor_k3l_loading" />
    <div v-if="hoverActive" class="k3l-kplh-tooltip">
      <div class="box-k3l-kplh-bg mr10" :style="`background-color: ${itemActive ? itemActive.color : 'transparant'};`
        ">
        &nbsp;
      </div>
      <div>
        <div>{{ itemActive ? itemActive.keterangan : '' }}</div>
        <div>{{ itemActive ? itemActive.total_keterangan : '' }}</div>
      </div>
    </div>
    <div class="pointer" style="position:absolute;right:2%;top:2%;font-size:20px;z-index: 100;">
      <i class="fa-solid fa-file-arrow-down" style="color:red" @click="downloadReport()"></i>
    </div>
    <div class="text-sm text-bold mb10">Praqualifikasi K3L Vendor</div>
    <div class="treemap-container cursor-pointer" v-if="totalVendor">
      <div :style="`
          width: calc(100% - ${100 - (totalMap1() / totalMap()) * 100}%);
          height: 100%
        `
        ">
        <div v-for="(item, index) in treemap" :key="index" :style="`
            width: 100%;
            height: calc(100% - ${totalTreemap(item.total_keterangan)}%);
            background-color:${item.color};
            display: flex;
          `
          ">
          <div class="text-white text-ssm w-full" @mouseenter="hoverOn(item)" @mouseleave="hoverOff">
            <div>{{ item.keterangan }}</div>
            <div>{{ item.total_keterangan }}</div>
          </div>
        </div>
      </div>
      <div :style="`
          width:calc(100% - ${100 - (totalRight() / totalMap()) * 100}%);
          heigth: 100%
        `
        ">
        <div :style="`
              width: 100%;
              height: calc(100% - ${100 - (totalMap2() / totalRight()) * 100}%);
              display: flex;
            `
          ">
          <div v-for="(item, index) in treemap2" :key="index + 10" :style="`
              width: 100%;
              height: calc(100% - ${totalTreemap2(item.total_keterangan)}%);
              background-color:${item.color};
              display: flex;
            `
            ">
            <div class="text-white text-ssm w-full" @mouseenter="hoverOn(item)" @mouseleave="hoverOff">
              <div>{{ item.keterangan }}</div>
              <div>{{ item.total_keterangan }}</div>
            </div>
          </div>
        </div>
        <div :style="`
            width: 100%;
            height: calc(100% - ${100 - (totalMap3() / totalRight()) * 100}%);
            display: flex;
          `
          ">
          <div v-for="(item, index) in treemap3" :key="index + 20" :style="`
              width: calc(100% - ${100 -
            (item.total_keterangan / totalMap3()) * 100}%);
              height: 100%;
              background-color:${item.color};
              display: flex;
            `
            ">
            <div class="text-white text-ssm w-full" @mouseenter="hoverOn(item)" @mouseleave="hoverOff">
              <div>{{ item.keterangan }}</div>
              <div>{{ item.total_keterangan }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as XLSX from 'sheetjs-style'
import moment from 'moment'
export default {
  components: {
    barChart: () => import('@/components/chart/dashboard/bar-chart.vue'),
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
  },
  data() {
    return {
      hoverActive: false,
      itemActive: null,
      treemap: [
        {
          keterangan: 'Low - C1',
          total_keterangan: 250,
          color: '#ff9900',
        },
        {
          keterangan: 'Low - C2',
          total_keterangan: 150,
          color: '#ff6600',
        },
      ],
      treemap2: [
        {
          keterangan: 'Medium - B2',
          total_keterangan: 150,
          color: '#ff3333',
        },
      ],
      treemap3: [
        {
          keterangan: 'Medium - B1',
          total_keterangan: 100,
          color: '#ff3333',
        },
        {
          keterangan: 'High - A1',
          total_keterangan: 50,
          color: '#990000',
        },
      ],
    }
  },
  created() {
    // this.$store.dispatch('vaStore/getTotalVendorK3L')
  },
  computed: {
    totalVendor() {
      const data = this.$store.state.vaStore.total_vendor_k3l
      this.convertData(data)
      return true
    },
  },
  methods: {
    hoverOn(item) {
      this.hoverActive = true
      this.itemActive = item
    },
    hoverOff(item) {
      this.hoverActive = false
      this.itemActive = null
    },
    convertData(data) {
      let treemap = []
      let treemap2 = []
      let treemap3 = []

      for (let i in data) {
        switch (data[i].keterangan.toUpperCase()) {
          case 'LOW C1':
            data[i].color = '#ff9966'
            break
          case 'LOW C2':
            data[i].color = '#ff9900'
            break
          case 'MEDIUM B2':
            data[i].color = '#ff6600'
            break
          case 'MEDIUM B1':
            data[i].color = '#ff3333'
            break
          case 'HIGH A':
            data[i].color = '#990000'
            break

          default:
            break
        }

        if (i < 2) {
          treemap.push(data[i])
        } else if (i == 2) {
          treemap2.push(data[i])
        } else {
          treemap3.push(data[i])
        }
      }
      this.treemap = treemap
      this.treemap2 = treemap2
      this.treemap3 = treemap3
    },
    totalTreemap(value) {
      if (this.treemap && this.treemap.length > 0) {
        const result = this.treemap.reduce(function (acc, obj) {
          return acc + obj.total_keterangan
        }, 0)
        // const maxValue = Math.max(...this.treemap.map(o => o.total_keterangan))
        return 100 - (value / result) * 100
      }
      return 0
    },
    totalTreemap2(value) {
      if (this.treemap2 && this.treemap2.length > 0) {
        const result = this.treemap2.reduce(function (acc, obj) {
          return acc + obj.total_keterangan
        }, 0)
        // const maxValue = Math.max(...this.treemap.map(o => o.total_keterangan))
        return 100 - (value / result) * 100
      }
      return 0
    },
    totalMap1(value) {
      if (this.treemap && this.treemap.length > 0) {
        const result = this.treemap.reduce(function (acc, obj) {
          return acc + obj.total_keterangan
        }, 0)
        // const maxValue = Math.max(...this.treemap.map(o => o.total_keterangan))
        return result
      }
      return 0
    },
    totalMap2(value) {
      if (this.treemap2 && this.treemap2.length > 0) {
        const result = this.treemap2.reduce(function (acc, obj) {
          return acc + obj.total_keterangan
        }, 0)
        // const maxValue = Math.max(...this.treemap.map(o => o.total_keterangan))
        return result
      }
      return 0
    },
    totalMap3(value) {
      if (this.treemap3 && this.treemap3.length > 0) {
        const result = this.treemap3.reduce(function (acc, obj) {
          return acc + obj.total_keterangan
        }, 0)
        // const maxValue = Math.max(...this.treemap.map(o => o.total_keterangan))
        return result
      }
      return 0
    },
    maxValueChart() {
      if (this.treemap && this.treemap.length > 0) {
        const maxValue = Math.max(...this.treemap.map(o => o.total_keterangan))
        return maxValue
      }
      return 0
    },
    maxValueChart2() {
      if (this.treemap2 && this.treemap2.length > 0) {
        const maxValue = Math.max(...this.treemap2.map(o => o.total_keterangan))
        return maxValue
      }
      return 0
    },
    maxValueChart3() {
      if (this.treemap3 && this.treemap3.length > 0) {
        const maxValue = Math.max(...this.treemap3.map(o => o.total_keterangan))
        return maxValue
      }
      return 0
    },
    maxValueTreeRight() {
      if (this.maxValueChart2() > this.maxValueChart3()) {
        return this.maxValueChart2()
      }
      return this.maxValueChart3()
    },
    maxValueTreeLeft() {
      if (this.maxValueChart() > this.maxValueTreeRight()) {
        return this.maxValueChart()
      }
      return this.maxValueTreeRight()
    },
    totalMaxValue() {
      return this.maxValueTreeLeft() + this.maxValueTreeRight()
    },

    totalMaxValueRight() {
      return this.maxValueChart2() + this.maxValueChart3()
    },
    totalRight() {
      return this.totalMap2() + this.totalMap3()
    },
    totalMap() {
      return this.totalMap1() + this.totalMap2() + this.totalMap3()
    },

    getMax() {
      let maxValue = 0
      let maxValue2 = 0

      if (this.treemap && this.treemap.length > 0) {
        maxValue = Math.max(...this.treemap.map(o => o.total_keterangan))
      }

      if (this.treemap2 && this.treemap2.length > 0) {
        maxValue2 = Math.max(...this.treemap2.map(o => o.total_keterangan))
      }

      if (maxValue > maxValue2) {
        return maxValue
      }
      return maxValue2
    },
    async downloadReport() {
      let dateReport = moment().format('DDMMYY')
      let daterange = ''
      let start = this.$store.state.vaStore.start
      let end = this.$store.state.vaStore.end

      if (start && end) {
        daterange += `${start} - ${end}`
      }

      const total = await this.$store.dispatch(
        'vaStore/getTotalVendorK3LExport'
      )
      total.unshift({})

      const newMapping = total.map(i => {
        return {
          isupplier_code: i.isupplier_code,
          vendor_id: i.vendor_id,
          nama_vendor: i.nama_vendor,
          pic: i.pic,
          last_reviewer: i.last_reviewer,
          keterangan:
            new Date().getTime() < new Date(i.tanggal_berakhir).getTime()
              ? 'Aktif'
              : 'Expired',
          tingkat_resiko: i.keterangan,
          tanggal_efektif: i.tanggal_efektif,
          tanggal_berakhir: i.tanggal_berakhir,
          nilai: i.nilai,
        }
      })

      let wb = XLSX.utils.book_new()

      let data = XLSX.utils.json_to_sheet(newMapping)
      const title = [
        [
          `Praqualifikasi_K3L${dateReport}`,
          daterange,
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          'Isupplier Code',
          'ID Vendor',
          'Nama Vendor',
          'PIC',
          'Last Reviewer',
          'Keterangan',
          'Tingkat Risiko',
          'Tanggal Efektif',
          'Tanggal Berakhir',
          'Nilai',
        ],
      ]
      XLSX.utils.book_append_sheet(wb, data, 'Report')
      XLSX.utils.sheet_add_aoa(data, title, {
        origin: 'A1',
      })
      XLSX.writeFile(wb, 'REPORT_PRAQUALIFIKASI_K3L.xlsx')
    },
  },
}
</script>
<style scoped>
.treemap-container {
  width: 100%;
  height: 87%;
  background-color: gray;
  display: flex;
}
</style>
